import { render, staticRenderFns } from "./ChargingPointDetail.vue?vue&type=template&id=38d86882"
import script from "./ChargingPointDetail.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetail.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointDetail.vue?vue&type=style&index=0&id=38d86882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports